<template>
  <HeaderPopup v-bind:onCloseClick="onCloseClick" v-bind:toggleButtonRef="toggleButtonRef">
    <div class="top-up-block">
      <HeaderPopupTitle class="top-up__title">Top up your balance</HeaderPopupTitle>
      <div class="balance-input">
        <span class="balance-currency">{{getCurrencySign(currency)}}</span>
        <Input
          v-bind:value="extraAmount"
          v-bind:onChange="changeStake"
          v-bind:alignRight="true"
        />
      </div>
      <div class="stakes">
        <StakeButton
          v-for="stake in stakes"
          class="stake"
          v-bind:key="stake"
          v-bind:label="stake"
          v-bind:onClick="() => changeStake(stake)"
          v-bind:isSelected="extraAmount === stake"
        />
      </div>
      <CtaButton
        class="button"
        label="Top up"
        v-bind:disabled="!extraAmount"
        v-bind:onClick="addMoney"
      />
    </div>
  </HeaderPopup>
</template>

<script>
import { mapState } from "vuex";
import HeaderPopup from "./HeaderPopup";
import Input from "../form/Input";
import CtaButton from "./CtaButton";
import StakeButton from "./StakeButton";
import HeaderPopupTitle from "../HeaderPopupTitle";
import getCurrencySign from "../../helpers/getCurrencySing";

export default {
  name: "TopUpBlock",
  components: {
    HeaderPopupTitle,
    HeaderPopup,
    Input,
    CtaButton,
    StakeButton
  },
  props: {
    onCloseClick: Function,
    toggleButtonRef: HTMLElement
  },
  data() {
    return {
      stakes: ["100", "500", "1000"],
      extraAmount: "100"
    };
  },
  computed: {
    ...mapState("auth", ["currency"]),
  },
  methods: {
    getCurrencySign,
    changeStake(stake) {
      this.extraAmount = stake;
    },
    addMoney() {
      this.$store.dispatch("balance/addMoney", { amount: this.extraAmount });
    }
  }
};
</script>

<style scoped>
.top-up-block {
  width: 296px;
  box-sizing: border-box;
  padding: 0 16px 40px;
}
.top-up__title {
  margin-bottom: 24px;
}
.balance-input {
  position: relative;
  margin: 8px 0 16px;
}
.balance-currency {
  position: absolute;
  top: 0;
  left: 8px;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  color: #8e989d;
}
.button {
  margin-top: 16px;
}
.stakes {
  display: flex;
}
.stake {
  flex: 1;
  margin-right: 8px;
}
.stake:last-of-type {
  margin-right: 0;
}

@media (max-width: 600px) {
  .top-up-block {
    width: 100%;
  }
  .stake {
    flex: 1;
  }
}
</style>
